import { get } from '@/utils/fetch'

export function getPowerBtn(data) {
  return get({
    url: 'manage/sys/iportal/getMenuInfo?appId=3&isShow=0',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/power.js